import { API_AUTH, setTokenGlobal } from "../common";
import { Cookies } from 'react-cookie';
import { getDomain } from 'utils/utils';

var urlNew = getDomain();
const cookies = new Cookies();
var token = cookies.get('userToken');
if (typeof token != "undefined" && token.length > 6) {
    token = token.substring(6);
    setTokenGlobal(token, urlNew);
}
export default {
    listChiNhanh: (params) => API_AUTH.get("chinhanh/listChiNhanh", params),
    listChiNhanhNoTong: (params) => API_AUTH.get("chinhanh/listChiNhanhNoTong", params),
    listChiNhanhNoTongTheoDaiLy: (params) => API_AUTH.get("chinhanh/listChiNhanhNoTongTheoDaiLy", params),
};
